import { FE_FAIRE_DIRECT_SIGNUP_EMAIL_AUTOFILL_250128 } from "@faire/retailer-settings/FE_FAIRE_DIRECT_SIGNUP_EMAIL_AUTOFILL_250128";
import { useAssignSetting, useSetting } from "@faire/retailer-visitor-shared/settings/__internal__/useSetting";
export var useSettingFaireDirectSignupEmailAutofill = function() {
    return useSetting(FE_FAIRE_DIRECT_SIGNUP_EMAIL_AUTOFILL_250128);
};
export var useAssignSettingFaireDirectSignupEmailAutofill = function() {
    return useAssignSetting(FE_FAIRE_DIRECT_SIGNUP_EMAIL_AUTOFILL_250128);
};
